var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import { phoneHeight, phoneWidth, phoneColor, phoneSecondaryColor, borderRadius, } from './constants';
export default styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  cursor: pointer;\n  height: ", ";\n  width: ", ";\n  background-color: ", ";\n  border-radius: ", ";\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  align-content: center;\n  justify-content: center;\n  transition: all 0.2s linear;\n  box-shadow: 0 10px\n    ", ";\n"], ["\n  position: relative;\n  cursor: pointer;\n  height: ",
    ";\n  width: ",
    ";\n  background-color: ",
    ";\n  border-radius: ", ";\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  align-content: center;\n  justify-content: center;\n  transition: all 0.2s linear;\n  box-shadow: 0 10px\n    ",
    ";\n"])), function (props) {
    return props.height ? props.height : phoneHeight + 'px';
}, function (props) {
    return props.width ? props.width : phoneWidth + 'px';
}, function (props) {
    return props.color ? props.color : phoneColor;
}, borderRadius, function (props) {
    return props.shadowColor ? props.shadowColor : phoneSecondaryColor;
});
var templateObject_1;
//# sourceMappingURL=Case.js.map